import React, {Component} from 'react';
import Intestazione from './components_novel/intestazione';
import Piedone from './components/piedone';
import Navbar from './components/navbar';
import Seo, {siteUrl} from './components/seo';
import {getArticlePath, getCreativeArticlesByPublishDate} from './data/creativeArticles';

import logo from './images/Logo-Verso-Hemelslinn-2.webp';
import intestazioneBackgroundImage from './images/verso-hemelslinn-sfondo-2.webp';
import authorImage from './images/foto-sito-web.webp';
import signatureImage from './images/firma.webp';
import versoCover from './images/Verso_Hemelslinn-Print-v.5.1-6x9-526x800-fronte.webp';
import essereCover from './images/Essere-1000x1500-72-fronte.webp';
import lettereCover from './images/Lettere-Fronte-v.2.5-110-5x8-938x1500-90.webp';

const pagePath = '/maurizio-feruglio/';
const pageTitle = 'Maurizio Feruglio | Autore ed editore indipendente';
const pageDescription =
  'Scopri Maurizio Feruglio, autore ed editore indipendente: i romanzi, Verso Hemelslinn, Eliosfera Editrice e gli articoli sulla scrittura.';
const crowdfundingUrl = 'https://hemelslinn.s.gy/vh-web-hem-land';
const newsletterUrl = 'https://towardhemelslinn.us11.list-manage.com/subscribe?u=81158fe55b1b7e6f79918d667&id=f6b53c0a1e';
const contactUrl = 'https://www.eliosfera.it/index.php?route=information/contact';
const authorImageUrl = `${siteUrl}/images/author/maurizio-feruglio-autore-verso-hemelslinn.webp`;
const versoCoverUrl = `${siteUrl}/images/author/verso-hemelslinn-maurizio-feruglio-copertina.webp`;
const essereCoverUrl = `${siteUrl}/images/author/essere-maurizio-feruglio-copertina.webp`;
const lettereCoverUrl = `${siteUrl}/images/author/lettere-storie-in-un-incipit-maurizio-feruglio.webp`;

const intestazioneBackgroundStyle = {
  backgroundImage: `url(${intestazioneBackgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundAttachment: 'fixed',
  height: '300px',
};

export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary.startsWith('/') ? urlOfTheLibrary : '/' + urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}

class MaurizioFeruglio extends Component {
  state = {
    aNavbarLinks: [
      {id: 0, linkHref: '/', linkNome: 'ROMANZO'},
      {id: 1, linkHref: '/cos-e-verso-hemelslinn/', linkNome: 'COS’È'},
      {id: 2, linkHref: '/articoli', linkNome: 'ARTICOLI'},
    ],
  };

  render() {
    const latestArticles = getCreativeArticlesByPublishDate().slice(0, 3);
    const pageJsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'ProfilePage',
          '@id': `${siteUrl}${pagePath}#webpage`,
          url: `${siteUrl}${pagePath}`,
          name: pageTitle,
          description:
            'Pagina ufficiale di Maurizio Feruglio, autore ed editore indipendente, fondatore di Eliosfera Editrice e autore di Verso Hemelslinn, ESSERE e LETTERE. Storie in un incipit.',
          mainEntity: {'@id': `${siteUrl}${pagePath}#person`},
          primaryImageOfPage: {'@id': `${siteUrl}${pagePath}#author-image`},
          inLanguage: 'it-IT',
        },
        {
          '@type': 'ImageObject',
          '@id': `${siteUrl}${pagePath}#author-image`,
          url: authorImageUrl,
          contentUrl: authorImageUrl,
          caption: 'Maurizio Feruglio, autore di Verso Hemelslinn',
        },
        {
          '@type': 'Person',
          '@id': `${siteUrl}${pagePath}#person`,
          name: 'Maurizio Feruglio',
          url: `${siteUrl}${pagePath}`,
          image: {'@id': `${siteUrl}${pagePath}#author-image`},
          description:
            'Autore ed editore indipendente, fondatore di Eliosfera Editrice e autore dei libri Verso Hemelslinn, ESSERE e LETTERE. Storie in un incipit.',
          jobTitle: ['Autore', 'Editore indipendente', 'Direttore editoriale'],
          hasOccupation: [
            {'@type': 'Occupation', name: 'Autore'},
            {'@type': 'Occupation', name: 'Editore indipendente'},
            {'@type': 'Occupation', name: 'IT Manager'},
            {'@type': 'Occupation', name: 'Sviluppatore software senior'},
            {'@type': 'Occupation', name: 'Amministratore di sistema senior'},
          ],
          founder: {'@id': 'https://www.eliosfera.it/#organization'},
          affiliation: {'@id': 'https://www.eliosfera.it/#organization'},
          knowsAbout: [
            'Scrittura creativa',
            'Fantascienza',
            'Space opera',
            'Narrativa fantastica',
            'Worldbuilding',
            'Costruzione dei personaggi',
            'Editoria',
            'Accessibilità degli ebook',
            'Sviluppo software',
            'Amministrazione di sistema',
            'IT management',
            'Modellazione tridimensionale',
          ],
          sameAs: [
            'https://www.facebook.com/maurizio.feruglio.68',
            'https://medium.com/@versohemelslinn',
            'https://www.goodreads.com/user/show/26867994-maurizio-feruglio',
            'https://www.anobii.com/it/mferuglio/profile/activity',
          ],
        },
        {
          '@type': 'Organization',
          '@id': 'https://www.eliosfera.it/#organization',
          name: 'Eliosfera Editrice',
          url: 'https://www.eliosfera.it',
          foundingDate: '2015',
          founder: {'@id': `${siteUrl}${pagePath}#person`},
        },
        {
          '@type': 'Book',
          '@id': `${siteUrl}/cos-e-verso-hemelslinn/#book`,
          name: 'Verso Hemelslinn',
          url: `${siteUrl}/cos-e-verso-hemelslinn/`,
          author: {'@id': `${siteUrl}${pagePath}#person`},
          publisher: {'@id': 'https://www.eliosfera.it/#organization'},
          isbn: '978-88-99387-15-0',
          numberOfPages: 420,
          inLanguage: 'it-IT',
          genre: ['Fantascienza', 'Space opera romantica', 'Avventura romantica fantascientifica'],
          image: versoCoverUrl,
        },
        {
          '@type': 'Book',
          '@id': 'https://www.eliosfera.it/maurizio-feruglio-essere-copertina-flessibile-libro#book',
          name: 'ESSERE',
          url: 'https://www.eliosfera.it/maurizio-feruglio-essere-copertina-flessibile-libro',
          author: {'@id': `${siteUrl}${pagePath}#person`},
          publisher: {'@id': 'https://www.eliosfera.it/#organization'},
          datePublished: '2024',
          isbn: ['978-88-99387-28-0', '978-88-99387-29-7', '978-88-99387-11-2'],
          inLanguage: 'it-IT',
          genre: ['Racconto lungo distopico', 'Narrativa visionaria'],
          image: essereCoverUrl,
        },
        {
          '@type': 'Book',
          '@id': 'https://www.eliosfera.it/maurizio-feruglio-lettere-storie-in-un-incipit-copertina-flessibile#book',
          name: 'LETTERE. Storie in un incipit',
          url: 'https://www.eliosfera.it/maurizio-feruglio-lettere-storie-in-un-incipit-copertina-flessibile',
          author: {'@id': `${siteUrl}${pagePath}#person`},
          publisher: {'@id': 'https://www.eliosfera.it/#organization'},
          datePublished: '2019',
          isbn: ['978-88-99387-20-4', '978-88-99387-21-1', '978-88-99387-22-8'],
          inLanguage: 'it-IT',
          genre: 'Raccolta di racconti',
          image: lettereCoverUrl,
        },
      ],
    };

    return (
      <>
        <div className="page">
          <Seo
            title={pageTitle}
            description={pageDescription}
            path={pagePath}
            image="/images/author/maurizio-feruglio-autore-verso-hemelslinn.webp"
            type="profile"
            jsonLd={pageJsonLd}
          />
          <Navbar
            linkSito="/"
            logo={logo}
            deskLogo="Logo di Verso Hemelslinn"
            brandName="Verso Hemelslinn"
            aNavbarLinks={this.state.aNavbarLinks}
          />
          <div id="pagina" className="author-page">
            <Intestazione
              pagina="AUTORE"
              backgroundStyle={intestazioneBackgroundStyle}
              titolo="MAURIZIO FERUGLIO"
              titoloAs="p"
              romanzo="autore ed editore indipendente"
              autore="VERSO HEMELSLINN"
            />

            <section className="ftco-section seo-pillar-section author-section">
              <div className="container">
                <article className="seo-pillar-shell author-shell">
                  <div className="author-hero-grid">
                    <figure>
                      <img src={authorImage} alt="Maurizio Feruglio, autore di Verso Hemelslinn" />
                      <figcaption>Maurizio Feruglio, autore ed editore indipendente</figcaption>
                    </figure>
                    <div>
                      <p className="landing-kicker">Autore</p>
                      <h1>Maurizio Feruglio</h1>
                      <p className="seo-pillar-lead">Autore ed editore indipendente</p>
                      <p className="author-hero-statement">
                        Scrivo storie per esplorare l’animo umano, dare forma ai sentimenti che spesso rimangono inespressi e immaginare mondi nei quali sia ancora possibile scegliere, amare e diventare pienamente sé stessi.
                      </p>
                    </div>
                  </div>

                  <p>
                    Maurizio Feruglio è autore ed editore indipendente. Scrive dal 1995 e ha fondato nel 2015 Eliosfera Editrice, un progetto nato dall’incontro tra narrativa, cura editoriale e tecnologia.
                  </p>
                  <p>
                    È autore della space opera romantica <em>Verso Hemelslinn</em>, del racconto lungo distopico <em>ESSERE</em> e della raccolta <em>LETTERE. Storie in un incipit</em>.
                  </p>
                  <p>
                    Tra i suoi progetti inediti figurano <em>Oltre Hemelslinn</em>, romanzo ambientato alcuni anni dopo gli eventi di <em>Verso Hemelslinn</em>; il racconto lungo <em>Sapienza</em>; il romanzo fantascientifico in sviluppo <em>LEI</em>; e il saggio-guida <em>Dal Tecnico IT all’IT Manager</em>.
                  </p>
                  <p>
                    Nelle sue opere ritornano il disagio interiore, il desiderio di comprendere il mondo, la ricerca di una maggiore consapevolezza e il bisogno di un amore autentico.
                  </p>
                  <p>
                    Racconto storie perché permettono di entrare in mondi nei quali si è liberi di amare, scegliere e vivere pienamente i propri sentimenti. Scrivere è anche un modo per mostrare agli altri una parte autentica di sé che, nella vita quotidiana, non sempre riesce a emergere.
                  </p>

                  <h2>I libri di Maurizio Feruglio</h2>
                  <div className="author-book-grid">
                    <article className="author-book-card">
                      <img src={versoCover} alt="Copertina di Verso Hemelslinn, romanzo di Maurizio Feruglio" />
                      <h3>Verso Hemelslinn</h3>
                      <p>Una space opera romantica italiana senza alieni, nella quale il viaggio nello spazio diventa anche un viaggio attraverso le relazioni, il tempo e le scelte che possono cambiare una vita.</p>
                      <p><em>Verso Hemelslinn</em> racconta un futuro interamente umano, fatto di astronavi, pianeti, tecnologie e grandi distanze.</p>
                      <p>Al centro della storia rimangono le persone: ciò che desiderano, ciò che temono di perdere e ciò che sono disposte a sacrificare.</p>
                      <p>La prima stesura completa fu scritta nell’estate del 1996, nell’arco di circa tre mesi. Il romanzo rimase poi a lungo nel cassetto e attraversò decenni di revisioni, correzioni ed elaborazione editoriale.</p>
                      <p>Oggi conta 420 pagine ed è al centro di una campagna di crowdfunding destinata alla realizzazione di una nuova edizione in copertina rigida.</p>
                      <p><strong>Genere:</strong> avventura romantica fantascientifica, space opera romantica<br /><strong>ISBN:</strong> 978-88-99387-15-0</p>
                      <a href="/cos-e-verso-hemelslinn/">Scopri cos’è Verso Hemelslinn</a>
                      <a href="/summary">Esplora il sommario</a>
                      <a href={crowdfundingUrl}>Sostieni la campagna</a>
                    </article>
                    <article className="author-book-card">
                      <img src={essereCover} alt="Copertina di ESSERE, racconto lungo di Maurizio Feruglio" />
                      <h3>ESSERE</h3>
                      <p>Un racconto lungo distopico e visionario sull’identità, sulla libertà e sul bisogno di comprendere il mondo nel quale si vive.</p>
                      <p>In <em>ESSERE</em>, la dimensione narrativa e quella psicologica si incontrano in una storia che esplora il rapporto tra individuo, realtà, condizionamento e ricerca di sé.</p>
                      <p><strong>Pubblicazione:</strong> 2024<br /><strong>Editore:</strong> Eliosfera Editrice<br /><strong>Formati:</strong> copertina flessibile, EPUB e Kindle</p>
                      <p><strong>ISBN</strong><br />copertina flessibile: 978-88-99387-28-0;<br />EPUB: 978-88-99387-29-7;<br />Kindle: 978-88-99387-11-2.</p>
                      <a href="https://www.eliosfera.it/maurizio-feruglio-essere-copertina-flessibile-libro">Scopri ESSERE</a>
                    </article>
                    <article className="author-book-card">
                      <img src={lettereCover} alt="Copertina di LETTERE. Storie in un incipit, di Maurizio Feruglio" />
                      <h3>LETTERE. Storie in un incipit</h3>
                      <p>Una raccolta nella quale l’incipit diventa la soglia attraverso cui entrare in storie, emozioni e possibilità narrative differenti.</p>
                      <p>Ogni racconto nasce dall’idea che poche righe possano contenere l’inizio di un mondo e che una storia possa aprirsi da una voce, una lettera o una situazione apparentemente ordinaria.</p>
                      <p><strong>Pubblicazione:</strong> 2019<br /><strong>Editore:</strong> Eliosfera Editrice<br /><strong>Formati:</strong> copertina flessibile, EPUB e Kindle</p>
                      <p><strong>ISBN</strong><br />copertina flessibile: 978-88-99387-20-4;<br />EPUB: 978-88-99387-21-1;<br />Kindle: 978-88-99387-22-8.</p>
                      <a href="https://www.eliosfera.it/maurizio-feruglio-lettere-storie-in-un-incipit-copertina-flessibile">Scopri LETTERE. Storie in un incipit</a>
                    </article>
                  </div>

                  <h2>Tra editoria, informatica e costruzione di mondi</h2>
                  <p>L’interesse di Maurizio Feruglio per i libri nasce molto prima della pubblicazione dei suoi romanzi.</p>
                  <p>
                    Da ragazzo raccoglieva riviste e articoli dedicati a uno stesso argomento, li organizzava in volumi tematici e li rilegava a mano. Utilizzava filo refe, colle da legatoria, cartone pressato e una piccola pressa in legno costruita personalmente, realizzando volumi in copertina rigida completi di risguardi.
                  </p>
                  <p>
                    Nel 1988 acquistò una macchina per scrivere elettronica Triumph-Adler SE-310, con la quale iniziò a scrivere e impaginare tesi e documenti per amici e conoscenti.
                  </p>
                  <p>
                    Con l’arrivo del primo computer, nel 1991, alla scrittura si affiancarono lo sviluppo software e il desktop publishing. Fra i primi lavori editoriali completi vi fu la preparazione di un saggio tecnico contenente centinaia di formule: dalla correzione del testo all’impaginazione, fino all’invio in tipografia e alla stampa di quattrocento copie.
                  </p>
                  <p>Parallelamente, dal 1990, Maurizio ha lavorato nel settore informatico come:</p>
                  <ul>
                    <li>sviluppatore software senior;</li>
                    <li>amministratore di sistema senior;</li>
                    <li>IT Manager.</li>
                  </ul>
                  <p>Questa esperienza ha influenzato anche la progettazione dei suoi mondi narrativi.</p>
                  <p>
                    Per <em>Verso Hemelslinn</em> ha costruito con Blender ambienti tridimensionali, sistemi planetari, astronavi e scenari. La copertina del romanzo nasce da uno di questi ambienti: è l’inquadratura di uno spazio tridimensionale comprendente pianeti e astronave.
                  </p>
                  <p>
                    Nel 2023 ha inoltre sviluppato un progetto sperimentale che univa letteratura, arte generativa e blockchain: diecimila variazioni della copertina di <em>Verso Hemelslinn</em>, ciascuna associata a una copia autenticata dell’ebook. Il progetto è stato successivamente sospeso.
                  </p>
                  <p>La sua esperienza professionale è anche alla base del saggio-guida in lavorazione <em>Dal Tecnico IT all’IT Manager</em>.</p>

                  <h2>Scrivere per esplorare ciò che abbiamo dentro</h2>
                  <p>Per Maurizio Feruglio, la scrittura non consiste soltanto nel costruire una trama.</p>
                  <p>È un modo per esplorare l’animo umano, comprendere le ragioni delle proprie scelte e dare voce a sentimenti che nella vita quotidiana possono rimanere inespressi.</p>
                  <p>Le storie permettono di attraversare mondi alternativi, sperimentare altre possibilità e osservare sé stessi da una prospettiva differente.</p>
                  <p>La fantascienza offre una libertà particolare: consente di immaginare situazioni impossibili nel presente, ma capaci di mettere in luce conflitti profondamente umani.</p>
                  <p><em>Verso Hemelslinn</em>, per esempio, nacque come una storia psicologica su alcuni astronauti isolati nello spazio. Durante la scrittura, le relazioni e i conflitti dei personaggi modificarono progressivamente il progetto, trasformandolo in un’avventura romantica fantascientifica.</p>
                  <p>Anche negli scenari più lontani, il centro della narrazione rimane l’essere umano.</p>
                  <p>La scrittura è stata anche uno strumento di riscoperta personale: un modo per riportare alla luce desideri, aspirazioni e sentimenti rimasti a lungo inespressi, trasformandoli in storie capaci di raggiungere altre persone.</p>
                  <p>Come scrisse un’amica dopo aver letto uno dei suoi racconti:</p>
                  <blockquote>
                    <p>«È stato per me fonte di pace, gioia e serenità.»</p>
                  </blockquote>

                  <h2>Opere inedite e progetti in sviluppo</h2>
                  <div className="seo-pillar-grid">
                    <div className="seo-pillar-card">
                      <h3>Oltre Hemelslinn</h3>
                      <p>Romanzo in fase di sviluppo.</p>
                      <p><em>Oltre Hemelslinn</em> riprende la storia alcuni anni dopo gli eventi narrati in <em>Verso Hemelslinn</em>.</p>
                      <p>Il progetto torna nell’universo del romanzo per esplorare le conseguenze delle scelte compiute dai personaggi, i cambiamenti avvenuti nel frattempo e le nuove direzioni assunte dalle loro vite.</p>
                      <p>È concepito come una prosecuzione narrativa di <em>Verso Hemelslinn</em>, ma si trova ancora in fase di sviluppo.</p>
                    </div>
                    <div className="seo-pillar-card">
                      <h3>Dal Tecnico IT all’IT Manager</h3>
                      <p>Saggio-guida in fase di scrittura.</p>
                      <p>Nasce dall’esperienza maturata nello sviluppo software, nell’amministrazione dei sistemi e nella gestione dell’IT. Affronta il passaggio dalle competenze tecniche alle responsabilità organizzative e strategiche dell’IT Manager.</p>
                    </div>
                    <div className="seo-pillar-card">
                      <h3>Sapienza</h3>
                      <p>Racconto lungo inedito.</p>
                      <p>Un progetto narrativo non ancora pubblicato, sul quale verranno fornite ulteriori informazioni durante il suo sviluppo editoriale.</p>
                    </div>
                    <div className="seo-pillar-card">
                      <h3>LEI</h3>
                      <p>Romanzo fantascientifico in fase di sviluppo — titolo provvisorio.</p>
                      <p>Un nuovo progetto narrativo con ambientazione fantascientifica. Il titolo potrà cambiare durante la scrittura e la revisione.</p>
                    </div>
                  </div>

                  <h2>Eliosfera Editrice</h2>
                  <p>Maurizio Feruglio ha fondato Eliosfera Editrice nel 2015, assumendo i ruoli di fondatore, editore e direttore editoriale.</p>
                  <p>Il progetto è nato per diffondere la cultura letteraria, pubblicare opere contemporanee e recuperare testi della letteratura italiana.</p>
                  <p>Il lavoro sulle opere appartenenti al pubblico dominio non si è limitato alla riproduzione di vecchie edizioni. I testi sono stati riesaminati, corretti e corredati di note, biografie letterarie e materiali di approfondimento. In alcuni casi è stato necessario eliminare errori che continuavano a essere trasmessi da un’edizione all’altra.</p>
                  <p>Gli ebook in formato EPUB sono realizzati in formato accessibile, seguendo le indicazioni del W3C e le WCAG 2.0 — Web Content Accessibility Guidelines. Sono progettati per essere fruiti anche da persone cieche e ipovedenti mediante screen reader e altre tecnologie assistive.</p>
                  <p>Tra le opere pubblicate da Eliosfera Editrice figurano testi di Giovanni Verga, Grazia Deledda, Luigi Pirandello e Lidia Angolini, oltre alle opere di Maurizio Feruglio.</p>
                  <p>Oggi Eliosfera opera soprattutto come marchio e progetto editoriale legato a <em>Verso Hemelslinn</em>, con l’obiettivo futuro di tornare a sviluppare nuovi progetti editoriali.</p>
                  <p><a href="https://www.eliosfera.it">Visita Eliosfera Editrice</a></p>

                  <img className="author-signature" src={signatureImage} alt="Firma di Maurizio Feruglio" />

                  <h2>Articoli sulla scrittura</h2>
                  <p>
                    Maurizio Feruglio firma gli articoli pubblicati sul sito di Verso Hemelslinn, su Medium e sul sito di Eliosfera.
                  </p>
                  <p>
                    Gli approfondimenti nascono dall’esperienza concreta di progettazione, scrittura, revisione ed edizione dei romanzi e sono organizzati in cinque percorsi.
                  </p>
                  <div className="seo-pillar-grid">
                    <div className="seo-pillar-card"><h3>Scrittura creativa</h3><p>Punto di vista, descrizione, dialogo, ritmo, scene e revisione.</p><a href="/scrittura-creativa/">Esplora la scrittura creativa</a></div>
                    <div className="seo-pillar-card"><h3>Personaggi</h3><p>Desideri, motivazioni, conflitti interiori, voce e trasformazione.</p><a href="/personaggi/">Esplora gli articoli sui personaggi</a></div>
                    <div className="seo-pillar-card"><h3>Worldbuilding</h3><p>Società, tecnologie, ambienti e coerenza dei mondi immaginari.</p><a href="/worldbuilding/">Esplora gli articoli sul worldbuilding</a></div>
                    <div className="seo-pillar-card"><h3>Relazioni nella fantascienza</h3><p>Amore, distanza, tempo, vulnerabilità e conflitti emotivi.</p><a href="/relazioni-nella-fantascienza/">Esplora le relazioni nella fantascienza</a></div>
                    <div className="seo-pillar-card"><h3>Produzione libri ed ebook</h3><p>Ebook accessibili, lettura digitale, file editoriali e produzione cartacea.</p><a href="/produzione-libri-ebook/">Esplora la produzione editoriale</a></div>
                  </div>

                  <h2>Ultimi articoli</h2>
                  <div className="creative-archive-grid author-latest-grid">
                    {latestArticles.map((article) => (
                      <article className="creative-archive-card" key={article.slug}>
                        <a href={getArticlePath(article)} className="creative-archive-image">
                          <img src={article.cover} alt={article.coverAlt} />
                        </a>
                        <div className="creative-archive-body">
                          <p className="creative-meta">{article.date} · {article.readingTime}</p>
                          <h3><a href={getArticlePath(article)}>{article.title}</a></h3>
                          <p className="author-article-path">Percorso tematico: {article.category || 'scrittura creativa'}</p>
                          <p>{article.excerpt}</p>
                          <a className="creative-text-link" href={getArticlePath(article)}>Leggi l’articolo</a>
                        </div>
                      </article>
                    ))}
                  </div>

                  <h2>Domande frequenti</h2>
                  <div className="seo-pillar-faq">
                    <details open>
                      <summary>Chi e Maurizio Feruglio?</summary>
                      <p>Maurizio Feruglio e autore ed editore indipendente, fondatore di Eliosfera Editrice e autore di <em>Verso Hemelslinn</em>.</p>
                    </details>
                    <details>
                      <summary>Dove posso leggere gli articoli?</summary>
                      <p>Gli articoli sono raccolti nell'<a href="/articoli">archivio del laboratorio narrativo</a> e nei percorsi dedicati a scrittura, personaggi, worldbuilding e relazioni.</p>
                    </details>
                    <details>
                      <summary>Dove posso seguire il progetto Verso Hemelslinn?</summary>
                      <p>Puoi seguire la <a href="https://hemelslinn.s.gy/vh-web-hem-land">campagna crowdfunding</a> e i canali social del progetto.</p>
                    </details>
                  </div>

                  <h2>Segui Maurizio Feruglio</h2>
                  <div className="author-link-grid">
                    <a href="https://medium.com/@versohemelslinn">Medium</a>
                    <a href="https://www.facebook.com/maurizio.feruglio.68">Facebook</a>
                    <a href="https://www.goodreads.com/user/show/26867994-maurizio-feruglio">Goodreads</a>
                    <a href="https://www.anobii.com/it/mferuglio/profile/activity">Anobii</a>
                  </div>

                  <h2>Segui Verso Hemelslinn</h2>
                  <div className="author-link-grid">
                    <a href="https://www.instagram.com/versohemelslinn/">Instagram</a>
                    <a href="https://www.tiktok.com/@hemelslinn">TikTok</a>
                    <a href="https://x.com/Hemelslinn">X</a>
                    <a href="https://www.youtube.com/@VersoHemelslinn">YouTube</a>
                    <a href="https://it.pinterest.com/hemelslinn/">Pinterest</a>
                  </div>

                  <div className="seo-pillar-actions author-actions">
                    <a className="btn btn-primary" href={newsletterUrl}>Iscriviti agli aggiornamenti</a>
                    <a className="btn btn-info" href={contactUrl}>Contatta Maurizio Feruglio</a>
                  </div>

                </article>
              </div>
            </section>

            <Piedone
              piedoneCallToAction="Ogni storia nasce da una voce. Qui puoi conoscere quella che guida Verso Hemelslinn."
              piedoneLinkTermConditions=""
              piedoneLinkCookies="/cookies"
              piedoneLinkPrivacy="/privacy"
              piedoneIframe=""
              piedoneTwitter="https://x.com/Hemelslinn"
              piedoneInstagram="https://www.instagram.com/versohemelslinn/"
              piedoneFacebook="https://www.facebook.com/hemelslinn"
              piedoneTiktok="https://www.tiktok.com/@hemelslinn"
              piedoneDiscord=""
              piedonePinterest="https://it.pinterest.com/hemelslinn/"
              piedoneOpensea=""
              piedoneEliosfera="https://www.eliosfera.it"
              piedoneYoutube="https://www.youtube.com/@VersoHemelslinn"
              piedoneCopyright="Eliosfera Editrice &copy;"
              piedoneCopyrightDisclaimer="Tutti i diritti riservati"
              piedoneCCBY='Template basato su <i class="icon-heart" aria-hidden="true"></i> <a href="https://colorlib.com" target="_blank">Colorlib</a>'
            />
          </div>

          {AddLibrary('js/jquery.min.js')}
          {AddLibrary('js/jquery-migrate-3.0.1.min.js')}
          {AddLibrary('js/jquery.waypoints.min.js')}
          {AddLibrary('js/jquery.stellar.min.js')}
          {AddLibrary('js/owl.carousel.min.js')}
          {AddLibrary('js/aos.js')}
          {AddLibrary('js/scrollax.min.js')}
          {AddLibrary('js/main.js')}
        </div>
      </>
    );
  }
}

export default MaurizioFeruglio;
